import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {concatMap, Observable, of, switchMap, takeUntil} from 'rxjs';
import {lastMap} from "../../rxjs/lastMap";
import {catchError, tap} from "rxjs/operators";


@Component({
  selector: 'app-knx',
  template: '<div #component>Knx</div>',
  styleUrls: []
})
export class KnxComponent extends PlayerBase {
  knx;
  knxData;
  connection;
  mapIn;
  mapOut;

  constructor(protected injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    const logInfo = Log.getLogInfo("KnxComponent", "load", []);
    let self;
    return super.load(playerObject).pipe(
      switchMap(playerBase => {
        self = playerBase;
        this.knxData = this.data.Knx[0].$;
        this.knx = (<any>window).require('knx');
        this.connection = this.knx.Connection({
          ipAddr: this.knxData.ip, // '192.168.14.73'
          handlers: {
            connected: () => {
              Log.d(logInfo, LogTag.PLAYER, 'Connected!');
            },
            event: (evt, src, dest, value) => {
              Log.d(logInfo, LogTag.PLAYER, 'knx' + evt + " " + " " + dest + " " + value);
              if (evt == "GroupValue_Write") {
                const params = {src: src, dest: dest, value: value};
                // 'knx'
                this.playerService.eventParams.dispatch(this.knxData.sendEvent, params, false);
              }
            }
          }
        });
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  //???
  playLoop(): Observable<any> {
    return of('loop').pipe(
      switchMap(r1 => {
        // 'knx_write'
        return this.playerService.eventParams.getEventParam(this.knxData.receivedEvent).pipe(
          switchMap(args => {
            this.connection.write(args.group, args.value, null, () => {
            });
            return of('write');
          })
        )
      })
    )
  }
}
